<div class="timezone-toggle-container" *ngIf="showToggle && config">
  <mat-checkbox
    [checked]="config.useLocalTimezone"
    (change)="onToggle()"
    color="primary">
    {{ checkboxLabel }}
  </mat-checkbox>
</div>
